import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Async } from "../../../../_shared";
import { SaveTicketValues, TicketData } from "../../../tickets";
import { SaveTicketValuesWithFullMeta } from "../types/SaveTicketValues";
import { TicketSaveForm } from "./TicketSaveForm";

export const TicketSaveModal = observer(
  (props: {
    open?: boolean;
    onClose?: () => void;
    initialValues?: SaveTicketValues;
    onSaveSuccess?: (
      response: TicketData,
      values: SaveTicketValuesWithFullMeta
    ) => Async<void>;
  }) => {
    return (
      <Modal
        forceRender
        open={props.open}
        onCancel={props.onClose}
        width="80%"
        destroyOnHidden
        footer={null}
        styles={{ body: { padding: "2.5rem" } }}
      >
        {props.open && (
          <TicketSaveForm
            initialValues={props.initialValues}
            onSaveSuccess={(response, values) => {
              props.onSaveSuccess?.(response, values);
              props.onClose?.();
            }}
          />
        )}
      </Modal>
    );
  }
);
